import { render, staticRenderFns } from "./TagsWhitelist.vue?vue&type=template&id=bca50192"
import script from "./TagsWhitelist.vue?vue&type=script&lang=js"
export * from "./TagsWhitelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports